export function isEighteen (dateString: string): boolean {
    const birthDate = new Date(dateString)
    const ageInMs = Date.now() - birthDate.getTime()
    const ageInYears = ageInMs / 1000 / 60 / 60 / 24 / 365.25
    return ageInYears >= 18
}
